module.exports = __webpack_public_path__ + "assets/img/frame-wood.807062a9.svg";